import http, { url } from '../../http'

const API_URL = "intervention-act"

class InterventionActAPI {

  async getAll(companyId, page = 1) {
    const response = await http(`${API_URL}/company/${companyId}?page=${page}`, 'GET')
    return response || null
  }

  async get(id) {
    const response = await http(`${API_URL}/${id}`, 'GET')
    return response || null
  }

  async save(data) {
    const response = await http(`${API_URL}/save`, 'POST', data)
    return response
  }

  async update(id, data) {
    const response = await http(`${API_URL}/update/${id}`, 'PUT', data)
    return response
  }

  async delete(id) {
    const response = await http(`${API_URL}/delete/${id}`, 'DELETE')
    return response
  }

  // Acta de Intervención branded: la app genera el PDF y el encargado firma.
  pdfUrl(id) {
    return url(`${API_URL}/${id}/pdf`)
  }

  async sign(id, payload) {
    return await http(`${API_URL}/${id}/sign`, 'POST', payload)
  }

  async status(id) {
    return await http(`${API_URL}/${id}/status`, 'GET')
  }
}

export default new InterventionActAPI()
